import { useLocation } from 'react-router-dom';
import { ROUTES } from '../../../../../common/constants';
import GoBackButton from '../../../../../components/GoBackButton';
import Portal from '../../../../../components/Portal';
import LibraryTabs from '../components/LibraryTabs';
import PincodeDeliveryTable from '../components/PincodeDeliveryTable';

const PincodeDelivery = ({
  match: { params: { id, libraryNumber } = {} } = {},
}) => {
  const location = useLocation();

  const isView = location?.pathname?.includes('/view/');

  return (
    <>
      <Portal portalId="header-title-content">
        <GoBackButton
          customLink={`${ROUTES?.MASTER_LISTS}${ROUTES?.LIBRARY}`}
        />
        <div className="portal-header">{isView ? 'View Library' : 'Edit Library'}</div>
      </Portal>

      <LibraryTabs libraryId={id} libraryNumber={libraryNumber} isView={isView}>
        <div className="full-height-without-details">
          <PincodeDeliveryTable
            libraryId={id}
            libraryNumber={libraryNumber}
          />
        </div>
      </LibraryTabs>
    </>
  );
};

export default PincodeDelivery;
